import { OFFER_TYPE_CARHIRE_SLUG, OFFER_TYPE_CRUISE_SLUG, OFFER_TYPE_HOTEL_SLUG, OFFER_TYPE_TOUR_SLUG, PRODUCT_TYPE_HOME_AND_VILLAS_SLUG, PRODUCT_TYPE_ULTRALUX_SLUG } from 'constants/offer'
import { LUXURY_PLUS, LUXURY_PLUS_PATHS } from 'loyalty/constants/base'

const asianCountries = ['SG', 'HK', 'IN', 'MY', 'TH', 'ID', 'PH', 'VN', 'CN', 'JP', 'KR', 'TW', 'MO', 'AE', 'SA', 'IL', 'QA']

const HOTELS_NAV_ITEM = {
  to: `/${OFFER_TYPE_HOTEL_SLUG}`,
  id: `nav-link-${OFFER_TYPE_HOTEL_SLUG}`,
  text: 'Hotels',
  testId: 'nav-link-hotels',
  iconName: 'bed',
  mobileNav: true,
}

const HOMES_VILLAS_NAV_ITEM = {
  to: `/${PRODUCT_TYPE_HOME_AND_VILLAS_SLUG}`,
  id: `nav-link-${PRODUCT_TYPE_HOME_AND_VILLAS_SLUG}`,
  text: 'Homes & Villas',
  iconName: 'home-alt',
  featureToggle: 'RENTALS_VERTICAL_ENABLED',
  newLabel: true,
}

const TOURS_NAV_ITEM = (env: App.EnvVarsAndFeatures): App.NavItem => ({
  to: `/${OFFER_TYPE_TOUR_SLUG}`,
  id: `nav-link-${OFFER_TYPE_TOUR_SLUG}`,
  text: 'Tours',
  testId: 'nav-link-tours',
  onlyOnRegions: env.STANDALONE_CRUISE_REGIONS?.split(',') ?? [],
  mobileNav: true,
  iconName: 'compass',
})

const TOURS_CRUISES_NAV_ITEM = (env: App.EnvVarsAndFeatures): App.NavItem => ({
  to: `/${OFFER_TYPE_TOUR_SLUG}`,
  id: `nav-link-${OFFER_TYPE_TOUR_SLUG}`,
  text: 'Tours & Cruises',
  testId: 'nav-link-tours',
  notOnRegions: env.STANDALONE_CRUISE_REGIONS?.split(',') ?? [],
  mobileNav: true,
  iconName: 'compass',
})

const CRUISES_NAV_ITEM = (env: App.EnvVarsAndFeatures): App.NavItem => ({
  to: `/${OFFER_TYPE_CRUISE_SLUG}`,
  id: `nav-link-${OFFER_TYPE_CRUISE_SLUG}`,
  text: 'Cruises',
  onlyOnRegions: env.STANDALONE_CRUISE_REGIONS?.split(','),
  mobileNav: true,
  testId: 'nav-link-cruises',
  featureToggle: 'CRUISES_STANDLONE_ENABLED',
  iconName: 'ship',
})

const FLIGHTS_NAV_ITEM = {
  to: '/flights',
  id: 'nav-link-flights',
  text: 'Flights',
  onlyOnRegions: ['AU', 'US', 'NZ', 'SG', 'HK', 'GB', 'IN'],
  mobileNav: true,
  iconName: 'plane-departure',
}

const CAR_HIRE_NAV_ITEM = (env: App.EnvVarsAndFeatures): App.NavItem => ({
  to: `/${OFFER_TYPE_CARHIRE_SLUG}`,
  id: `nav-link-${OFFER_TYPE_CARHIRE_SLUG}`,
  text: 'Car Hire',
  testId: 'nav-link-car-hire',
  onlyOnRegions: env.CARHIRE_REGIONS.split(','),
  mobileNav: true,
  iconName: 'car',
  featureToggle: 'CARHIRE_ENABLED',
})

const ULTRA_LUX_NAV_ITEM = {
  to: `/${PRODUCT_TYPE_ULTRALUX_SLUG}`,
  id: 'nav-link-ultralux',
  text: 'Ultra Lux',
  mobileNav: true,
  testId: 'nav-link-ultralux',
  featureToggle: 'ULTRALUX_ENABLED',
  iconName: 'ultra-lux-diamond',
}

const EXPERIENCES_NAV_ITEM = {
  to: '/experiences',
  id: 'nav-link-experiences',
  text: 'Experiences',
  notOnRegions: asianCountries.filter(c => c !== 'SG'),
  mobileNav: true,
  iconName: 'hot-air-balloon',
}

const LUXURY_PLUS_NAV_ITEM = {
  to: `/${LUXURY_PLUS_PATHS.LANDING_PAGE}`,
  id: 'nav-link-luxury-plus',
  newLabel: true,
  text: LUXURY_PLUS.PROGRAM_NAME,
  mobileNav: true,
  luxPlusToggle: 'luxuryPlusEnabled',
}

const INSPIRATION_NAV_ITEM = {
  href: 'https://luxuryescapes.com/inspiration/',
  target: '_blank',
  id: 'nav-link-inspiration',
  text: 'Inspiration',
  testId: 'nav-link-inspiration',
  hideInStoreMode: true,
  mobileNav: true,
}

const SUPPORT_NAV_ITEM = {
  to: '/support',
  id: 'nav-link-support',
  text: 'Support',
  mobileNav: true,
  hideInStoreMode: true,
}

const VISTARA_NAV_ITEM = {
  to: '/club-vistara',
  id: 'nav-link-vistara',
  text: 'Earn Vistara Points',
  onlyOnRegions: ['IN'],
}

const KRISFLYER_NAV_ITEM = {
  to: '/krisflyer',
  id: 'nav-link-krisflyer',
  text: 'Earn KrisFlyer miles',
  onlyOnRegions: ['SG', 'HK', 'MY', 'TH', 'ID', 'PH', 'VN', 'CN', 'JP', 'KR', 'TW'],
}

// Disabled until the next revamp
// const LAST_MINUTE_ESCAPE_NAV_ITEM = {
//   to: `/${OFFER_TYPE_LAST_MINUTE_SLUG}`,
//   id: `nav-link-${OFFER_TYPE_LAST_MINUTE_SLUG}`,
//   text: LAST_MINUTE_PRODUCT_NAME,
//   lastMinuteToggle: LAST_MINUTE_PRODUCT_CODE,
//   iconName: 'stopwatch',
// }

const GIFT_CARD_NAV_ITEM = {
  to: '/gift-cards',
  id: 'nav-link-gift-cards',
  text: 'Gift Cards',
  testId: 'nav-link-gift-cards',
}

const INSURANCE_NAV_ITEM = {
  to: '/insurance',
  id: 'nav-link-insurance',
  text: 'Travel Insurance',
  onlyOnRegions: ['AU', 'SG', 'HK', 'IN', 'MY', 'TH'],
}

const REFER_NAV_ITEM = {
  to: '/refer',
  id: 'nav-link-refer',
  text: 'Refer a Friend',
  accountToggle: 'referralProgramEnabled',
  testId: 'nav-link-refer',
}

const VELOCITY_NAV_ITEM = {
  to: '/velocity-frequent-flyer',
  id: 'velocity-frequent-flyer',
  text: 'Velocity Frequent Flyer',
  onlyOnRegions: ['AU'],
}

const CURATED_TRIPS_NAV_ITEM = (env: App.EnvVarsAndFeatures): App.NavItem => ({
  to: '/trip-planner/curated',
  id: 'nav-link-curated-trips',
  text: 'Curated Trips',
  featureToggle: 'ENABLE_TRIP_PLANNER',
  onlyOnRegions: env.TRIP_PLANNER_REGIONS?.split(','),
})

const MORE_DROPDOWN_NAV_ITEM = (items: App.NavItem[]) => ({
  id: 'nav-link-more',
  text: 'More',
  hasDropdown: true,
  testId: 'nav-link-more',
  mobileNav: true,
  hideOnTablet: true,
  items,
})

export const SPECIFIC_ORDER_REGIONS_LIST = new Set(['AU', 'NZ', 'GB', 'US', 'SG', 'IN'])

export const getOrderedItemsByRegion = (env: App.EnvVarsAndFeatures): App.NavItemByRegion => {
  return {
    AU: [
      HOTELS_NAV_ITEM,
      TOURS_NAV_ITEM(env),
      CRUISES_NAV_ITEM(env),
      HOMES_VILLAS_NAV_ITEM,
      EXPERIENCES_NAV_ITEM,
      FLIGHTS_NAV_ITEM,
      LUXURY_PLUS_NAV_ITEM,
      INSPIRATION_NAV_ITEM,
      SUPPORT_NAV_ITEM,
      MORE_DROPDOWN_NAV_ITEM([
        ULTRA_LUX_NAV_ITEM,
        CAR_HIRE_NAV_ITEM(env),
        // LAST_MINUTE_ESCAPE_NAV_ITEM,
        GIFT_CARD_NAV_ITEM,
        INSURANCE_NAV_ITEM,
        REFER_NAV_ITEM,
        VELOCITY_NAV_ITEM,
        CURATED_TRIPS_NAV_ITEM(env),
      ]),
    ],
    NZ: [
      HOTELS_NAV_ITEM,
      TOURS_NAV_ITEM(env),
      CRUISES_NAV_ITEM(env),
      HOMES_VILLAS_NAV_ITEM,
      EXPERIENCES_NAV_ITEM,
      FLIGHTS_NAV_ITEM,
      LUXURY_PLUS_NAV_ITEM,
      INSPIRATION_NAV_ITEM,
      SUPPORT_NAV_ITEM,
      MORE_DROPDOWN_NAV_ITEM([
        ULTRA_LUX_NAV_ITEM,
        CAR_HIRE_NAV_ITEM(env),
        // LAST_MINUTE_ESCAPE_NAV_ITEM,
        GIFT_CARD_NAV_ITEM,
        INSURANCE_NAV_ITEM,
        REFER_NAV_ITEM,
        VELOCITY_NAV_ITEM,
        CURATED_TRIPS_NAV_ITEM(env),
      ]),
    ],
    GB: [
      HOTELS_NAV_ITEM,
      HOMES_VILLAS_NAV_ITEM,
      TOURS_CRUISES_NAV_ITEM(env),
      EXPERIENCES_NAV_ITEM,
      FLIGHTS_NAV_ITEM,
      LUXURY_PLUS_NAV_ITEM,
      INSPIRATION_NAV_ITEM,
      SUPPORT_NAV_ITEM,
      MORE_DROPDOWN_NAV_ITEM([
        ULTRA_LUX_NAV_ITEM,
        CAR_HIRE_NAV_ITEM(env),
        GIFT_CARD_NAV_ITEM,
        REFER_NAV_ITEM,
        CURATED_TRIPS_NAV_ITEM(env),
      ]),
    ],
    US: [
      HOTELS_NAV_ITEM,
      TOURS_CRUISES_NAV_ITEM(env),
      HOMES_VILLAS_NAV_ITEM,
      EXPERIENCES_NAV_ITEM,
      FLIGHTS_NAV_ITEM,
      LUXURY_PLUS_NAV_ITEM,
      INSPIRATION_NAV_ITEM,
      SUPPORT_NAV_ITEM,
      MORE_DROPDOWN_NAV_ITEM([
        ULTRA_LUX_NAV_ITEM,
        CAR_HIRE_NAV_ITEM(env),
        GIFT_CARD_NAV_ITEM,
        REFER_NAV_ITEM,
        CURATED_TRIPS_NAV_ITEM(env),
      ]),
    ],
    SG: [
      HOTELS_NAV_ITEM,
      TOURS_CRUISES_NAV_ITEM(env),
      HOMES_VILLAS_NAV_ITEM,
      EXPERIENCES_NAV_ITEM,
      FLIGHTS_NAV_ITEM,
      LUXURY_PLUS_NAV_ITEM,
      INSPIRATION_NAV_ITEM,
      SUPPORT_NAV_ITEM,
      MORE_DROPDOWN_NAV_ITEM([
        ULTRA_LUX_NAV_ITEM,
        CAR_HIRE_NAV_ITEM(env),
        KRISFLYER_NAV_ITEM,
        GIFT_CARD_NAV_ITEM,
        REFER_NAV_ITEM,
        CURATED_TRIPS_NAV_ITEM(env),
      ]),
    ],
    IN: [
      HOTELS_NAV_ITEM,
      TOURS_CRUISES_NAV_ITEM(env),
      HOMES_VILLAS_NAV_ITEM,
      ULTRA_LUX_NAV_ITEM,
      FLIGHTS_NAV_ITEM,
      LUXURY_PLUS_NAV_ITEM,
      INSPIRATION_NAV_ITEM,
      SUPPORT_NAV_ITEM,
      MORE_DROPDOWN_NAV_ITEM([
        CAR_HIRE_NAV_ITEM(env),
        VISTARA_NAV_ITEM,
        GIFT_CARD_NAV_ITEM,
        REFER_NAV_ITEM,
        CURATED_TRIPS_NAV_ITEM(env),
      ]),
    ],
    DEFAULT: [
      HOTELS_NAV_ITEM,
      HOMES_VILLAS_NAV_ITEM,
      TOURS_CRUISES_NAV_ITEM(env),
      CRUISES_NAV_ITEM(env),
      ULTRA_LUX_NAV_ITEM,
      EXPERIENCES_NAV_ITEM,
      FLIGHTS_NAV_ITEM,
      LUXURY_PLUS_NAV_ITEM,
      INSPIRATION_NAV_ITEM,
      SUPPORT_NAV_ITEM,
      MORE_DROPDOWN_NAV_ITEM([
        CAR_HIRE_NAV_ITEM(env),
        // LAST_MINUTE_ESCAPE_NAV_ITEM,
        GIFT_CARD_NAV_ITEM,
        INSURANCE_NAV_ITEM,
        REFER_NAV_ITEM,
        VELOCITY_NAV_ITEM,
        CURATED_TRIPS_NAV_ITEM(env),
      ]),
    ],
  }
}

export const getVariantOrderedItemsByRegion = (env: App.EnvVarsAndFeatures): App.NavItemByRegion => {
  return {
    AU: [
      HOTELS_NAV_ITEM,
      TOURS_NAV_ITEM(env),
      CRUISES_NAV_ITEM(env),
      FLIGHTS_NAV_ITEM,
      EXPERIENCES_NAV_ITEM,
      HOMES_VILLAS_NAV_ITEM,
      LUXURY_PLUS_NAV_ITEM,
      INSPIRATION_NAV_ITEM,
      SUPPORT_NAV_ITEM,
      MORE_DROPDOWN_NAV_ITEM([
        ULTRA_LUX_NAV_ITEM,
        CAR_HIRE_NAV_ITEM(env),
        // LAST_MINUTE_ESCAPE_NAV_ITEM,
        GIFT_CARD_NAV_ITEM,
        INSURANCE_NAV_ITEM,
        REFER_NAV_ITEM,
        VELOCITY_NAV_ITEM,
      ]),
    ],
    NZ: [
      HOTELS_NAV_ITEM,
      TOURS_NAV_ITEM(env),
      CRUISES_NAV_ITEM(env),
      FLIGHTS_NAV_ITEM,
      EXPERIENCES_NAV_ITEM,
      HOMES_VILLAS_NAV_ITEM,
      LUXURY_PLUS_NAV_ITEM,
      INSPIRATION_NAV_ITEM,
      SUPPORT_NAV_ITEM,
      MORE_DROPDOWN_NAV_ITEM([
        ULTRA_LUX_NAV_ITEM,
        CAR_HIRE_NAV_ITEM(env),
        // LAST_MINUTE_ESCAPE_NAV_ITEM,
        GIFT_CARD_NAV_ITEM,
        REFER_NAV_ITEM,
      ]),
    ],
    GB: [
      HOTELS_NAV_ITEM,
      TOURS_CRUISES_NAV_ITEM(env),
      FLIGHTS_NAV_ITEM,
      HOMES_VILLAS_NAV_ITEM,
      EXPERIENCES_NAV_ITEM,
      LUXURY_PLUS_NAV_ITEM,
      INSPIRATION_NAV_ITEM,
      SUPPORT_NAV_ITEM,
      MORE_DROPDOWN_NAV_ITEM([
        ULTRA_LUX_NAV_ITEM,
        CAR_HIRE_NAV_ITEM(env),
        GIFT_CARD_NAV_ITEM,
        REFER_NAV_ITEM,
      ]),
    ],
    US: [
      HOTELS_NAV_ITEM,
      TOURS_CRUISES_NAV_ITEM(env),
      FLIGHTS_NAV_ITEM,
      EXPERIENCES_NAV_ITEM,
      HOMES_VILLAS_NAV_ITEM,
      LUXURY_PLUS_NAV_ITEM,
      INSPIRATION_NAV_ITEM,
      SUPPORT_NAV_ITEM,
      MORE_DROPDOWN_NAV_ITEM([
        ULTRA_LUX_NAV_ITEM,
        CAR_HIRE_NAV_ITEM(env),
        GIFT_CARD_NAV_ITEM,
        REFER_NAV_ITEM,
      ]),
    ],
    SG: [
      HOTELS_NAV_ITEM,
      TOURS_CRUISES_NAV_ITEM(env),
      FLIGHTS_NAV_ITEM,
      EXPERIENCES_NAV_ITEM,
      LUXURY_PLUS_NAV_ITEM,
      INSPIRATION_NAV_ITEM,
      SUPPORT_NAV_ITEM,
      MORE_DROPDOWN_NAV_ITEM([
        ULTRA_LUX_NAV_ITEM,
        GIFT_CARD_NAV_ITEM,
        REFER_NAV_ITEM,
        KRISFLYER_NAV_ITEM,
      ]),
    ],
    IN: [
      HOTELS_NAV_ITEM,
      TOURS_CRUISES_NAV_ITEM(env),
      ULTRA_LUX_NAV_ITEM,
      FLIGHTS_NAV_ITEM,
      LUXURY_PLUS_NAV_ITEM,
      INSPIRATION_NAV_ITEM,
      SUPPORT_NAV_ITEM,
      MORE_DROPDOWN_NAV_ITEM([
        GIFT_CARD_NAV_ITEM,
        REFER_NAV_ITEM,
        VISTARA_NAV_ITEM,
      ]),
    ],
    DEFAULT: [
      HOTELS_NAV_ITEM,
      HOMES_VILLAS_NAV_ITEM,
      TOURS_CRUISES_NAV_ITEM(env),
      CRUISES_NAV_ITEM(env),
      ULTRA_LUX_NAV_ITEM,
      FLIGHTS_NAV_ITEM,
      EXPERIENCES_NAV_ITEM,
      LUXURY_PLUS_NAV_ITEM,
      INSPIRATION_NAV_ITEM,
      SUPPORT_NAV_ITEM,
      MORE_DROPDOWN_NAV_ITEM([
        CAR_HIRE_NAV_ITEM(env),
        // LAST_MINUTE_ESCAPE_NAV_ITEM,
        GIFT_CARD_NAV_ITEM,
        INSURANCE_NAV_ITEM,
        REFER_NAV_ITEM,
        VELOCITY_NAV_ITEM,
      ]),
    ],
  }
}
